var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInstanceSegmentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0V20H0V0H24ZM16 8V10L9 14V16L16 12V14L9 18H2V2H9V4L12.5 2H16L9 6V8L16 4V6L9 10V12L16 8ZM12.5 18L16 16V18H12.5Z",
    fill: "#1E63F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstanceSegmentation);
export default __webpack_public_path__ + "static/media/icon-instanceSegmentation.b3d56fe56a31346b678df1c057faec7e.svg";
export { ForwardRef as ReactComponent };